import { Box, Skeleton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import NavBarComponent from '../NavBar/NavBar';
import { FC, useContext, useState } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { FullScreenDialog } from '../FullScreenDialog/FullScreenDialog';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';
import { useAnalytics } from '@hooks/useAnalytics';
import { InvestigationContext } from '@context/InvestigationContext';
import FooterComponent from '../Footer/Footer';
import { NoteBox } from './NoteBox/NoteBox';
import { EnlargeButtonWithoutTextOnImage } from '../Questions/CheckQuestion/EnlargeButtonVariants';

interface Props {
	partyName: string;
	mainText: string;
	noteText: string;
	checkImageURL: string;
	checkAmount: string;
	checkNumber: string;
}

export const CutoffScreen: FC<Props> = ({ partyName, checkNumber, checkAmount, checkImageURL, mainText, noteText }) => {
	const { WelcomeScreen: text } = useContext(LocalizationContext);
	const [isCheckLoading, setIsCheckLoading] = useState(false);
	const [isFullScreenOpen, setFullScreenOpen] = useState(false);

	const { trackRefineEvent } = useAnalytics();
	const { setSupportLandscape } = useContext(InvestigationContext);
	const { OUCF } = useContext(LocalizationContext);

	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

	const handleCloseFullScreenDialog = () => {
		setFullScreenOpen(false);
		setSupportLandscape(false);
	};

	const handleEnlargeButtonClick = () => {
		setSupportLandscape(true);
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OUCF_CUSTOMER_ELRAGES_CHECK_IMAGE);
		setFullScreenOpen(true);
	};

	return (
		<Stack data-cy={'oucfCutoffScreen'} height={'100svh'} width={'100%'}>
			<NavBarComponent isQuestionTrailDisplayed={false} showLanguageSelector={false} />
			<Stack
				paddingInline={{
					xxs: '24px',
					xs: '24px',
					sm: '48px',
					md: '105px',
					lg: '350px',
					xl: '403px',
				}}
				paddingTop={{
					xxs: '16px',
					xs: '16px',
					sm: '32px',
					md: '32px',
					lg: '32px',
					xl: '32px',
				}}
				height={'100%'}
				justifyContent={'start'}
				alignItems={'start'}
				gap={{
					xxs: '16px',
					xs: '16px',
					sm: '36px',
					md: '36px',
					lg: '36px',
					xl: '36px',
				}}>
				<Stack justifyContent={'start'} alignItems={'start'} gap={'14px'}>
					<Stack tabIndex={0} aria-label={text.Greeting.replace('%1$s', partyName)}>
						<Typography variant={'welcomeScreenName'}>
							{text.Greeting.replace('%1$s', partyName) + ','}
						</Typography>
					</Stack>
					<Stack maxWidth={'600px'} aria-label={mainText}>
						<Typography variant={'contextText'} data-cy={'pqBankerOutreachText'}>
							{mainText}
						</Typography>
					</Stack>
				</Stack>
				{/*{isDesktop && <Divider orientation={'horizontal'} flexItem />}*/}
				<Box
					sx={{
						position: 'relative',
						paddingInline: '2px',
						width: isDesktop ? 'auto' : '100%',
					}}>
					{/*{isDesktop && (*/}
					{/*	<Stack paddingBottom={'4px'} direction={'row'} justifyContent={'space-between'}>*/}
					{/*		<Typography sx={{ ...refineFonts.xLargeRegular }}>Check number {checkNumber}</Typography>*/}
					{/*		<Typography sx={{ ...refineFonts.xLargeBold }}>${checkAmount}</Typography>*/}
					{/*	</Stack>*/}
					{/*)}*/}

					{isCheckLoading && <Skeleton sx={{ height: '150px', width: '100%' }} animation={'wave'} />}
					<img
						data-cy={'oucfCheckImage'}
						onLoad={() => {
							setIsCheckLoading(false);
						}}
						style={{
							display: isCheckLoading ? 'none' : 'block',
							maxHeight: '220px',
							objectFit: 'cover',
							borderRadius: '10px',
							border: '1.5px solid #B2C5FF',
							boxShadow: '0px 0px 6px 0px rgba(15, 21, 47, 0.05), 0px 3px 6px 0px rgba(15, 21, 47, 0.05)',
						}}
						width={'100%'}
						src={checkImageURL}
						alt="Check"
					/>

					<FullScreenDialog
						isOpen={isFullScreenOpen}
						onClose={handleCloseFullScreenDialog}
						imageResourcesPath={checkImageURL}
					/>
					{!isCheckLoading && (
						<EnlargeButtonWithoutTextOnImage
							buttonText={OUCF.EnlargeCheckButtonText}
							onClick={handleEnlargeButtonClick}
						/>
					)}
				</Box>
				<NoteBox title={'Please note'} message={noteText} />
			</Stack>
			<FooterComponent />
		</Stack>
	);
};
